/*常量文件*/

//银行到账公示状态
const bankReceived_collected_status = [
  { Key: 0, Text: "待认领" },
  { Key: 1, Text: "认领中", Color: "#1e90ff" },
  { Key: 2, Text: "已认领", Color: "#080" },
];

//开票记录状态
const invoiceapply_status = [
  { Key: 0, Text: "待开票" },
  { Key: 1, Text: "已开票", Color: "#080" },
  { Key: 2, Text: "审核不通过", Color: "#f00" },
];

//开票记录状态
const invoice_status = [
  { Key: 0, Text: "待开票" },
  { Key: 1, Text: "已开票", Color: "#080" },
  { Key: 2, Text: "审核不通过", Color: "#f00" },
];

//工资表员工明细算税状态
const payrollemployee_tax_status = [
  { Key: 0, Text: "未算税" },
  { Key: 1, Text: "算税中", Color: "#1e90ff" },
  { Key: 2, Text: "已算税", Color: "#080" },
  { Key: 3, Text: "算税失败", Color: "#f00" },
  { Key: 999, Text: "异常", Color: "#f00" },
];

//工资表员工明细发放状态
const payrollemployee_pay_status = [
  { Key: 0, Text: "未发放" },
  { Key: 1, Text: "已申请", Color: "#ffa500" },
  { Key: 2, Text: "发放中", Color: "#1e90ff" },
  { Key: 3, Text: "已发放", Color: "#080" },
  { Key: 4, Text: "发放失败", Color: "#f00" },
];

//员工报送状态
const employeedeclare_declare_status = [
  { Key: -1, Text: "报送中", Color: "#1e90ff" },
  { Key: 0, Text: "未报送" },
  { Key: 1, Text: "已报送", Color: "#080" },
  { Key: 2, Text: "报送失败", Color: "#f00" },
];

export default {
  bankReceived_collected_status,
  invoiceapply_status,
  invoice_status,
  payrollemployee_tax_status,
  payrollemployee_pay_status,
  employeedeclare_declare_status,
};
